module.exports = __webpack_public_path__ + "static/media/1.0ef7fa65.jpg";